import * as mProgramMapAdActions from '../actions/mProgramMapAdActions';
import PropTypes from 'prop-types';
import React from 'react';
import SuperLink from './SuperLink';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';


class MProgramMapAd extends React.Component{
  componentDidMount(){
    if(this.props.cmsId){
      // this.props.actions.initMProgramMapAd(this.props.cmsId);
    }
    else{
      // Additional setup
      //console.log(this.props);
    }
  }


  renderDescription(){
    const description =
      this.props.mProgramMapAd.description || this.props.mProgramMapAd.Description;
    if(!description) return null;

    return (
      <div className="m-programmapad__description">
        {description}
      </div>
    );
  }
  renderTitle(){
    const title = this.props.mProgramMapAd.title || this.props.mProgramMapAd.Title;
    if(!title) return null;

    return (
      <div className="m-programmapad__title">
        {title}
      </div>
    );
  }
  render(){
    const title = this.props.mProgramMapAd && (this.props.mProgramMapAd.title || this.props.mProgramMapAd.Title);
    const description =
      this.props.mProgramMapAd &&
      (this.props.mProgramMapAd.description || this.props.mProgramMapAd.Description);
    if(!this.props.mProgramMapAd ||
       !this.props.program ||
       (!description && !title)) return null;

    return (
      <SuperLink className={`m-programmapad ${this.props.className || ''}`}
                 to={`/programs/${this.props.program.slug}/maps`}>
        <div className="container container--coupling">
          <div className="m-programmapad__container">
            <div className="m-programmapad__sizer"></div>
            <div className="m-programmapad__content">
              {this.renderTitle()}
              {this.renderDescription()}
            </div>
          </div>
        </div>
      </SuperLink>
    );
  }
}


export default withRouter(connect(
  dispatch => ({
    actions: bindActionCreators(mProgramMapAdActions, dispatch),
  }),
)(MProgramMapAd));


MProgramMapAd.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  mProgramMapAd: PropTypes.object,
  program: PropTypes.object,
};
